import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';
import getECommercePageCounts from 'editor/src/store/variants/selector/getECommercePageCounts';

import { RootState } from 'editor/src/store';

import { PageStepDirection } from '../types';
import getSpreadCountForIncrement from '../util/getSpreadCountForIncrement';
import { legacyGetSpreadCountForIncrement } from '../util/legacyPageCountRules';
import resolveTemplateSpreadIndex from '../util/resolveTemplateSpreadIndex';

// How many pages a single add / duplicate / remove-pages click changes for the
// given spread — the number to show in the page-menu labels instead of a
// hardcoded value. The operations move one grid step's worth of spreads
// (getSpreadCountForIncrement): a removal takes this spread's, an add copies the
// template spread's, so the page delta is spreads-per-step × pages of that
// spread. Adding and removing can differ when the sold page counts are unevenly
// spaced. Returns 0 only without a design: a step whole spreads cannot make
// leaves the button disabled, and its label still names one spread's pages.
function getPagesPerStep(state: RootState, spreadIndex: number, direction: PageStepDirection): number {
  const { designData } = state.design;
  if (!designData) {
    return 0;
  }

  if (!isPageCountOptionsEnabled(state)) {
    const spreadsPerStep = legacyGetSpreadCountForIncrement(designData, spreadIndex, getECommercePageCounts(state));
    const pagesPerSpread = designData.spreads[spreadIndex]?.pages.length || 1;
    return spreadsPerStep * pagesPerSpread;
  }

  const stepSpreadIndex =
    direction === 'add' ? resolveTemplateSpreadIndex(designData, spreadIndex) ?? spreadIndex : spreadIndex;
  const spreadsPerStep = getSpreadCountForIncrement(
    designData,
    stepSpreadIndex,
    direction,
    getECommercePageCounts(state),
  );
  const pagesPerSpread = designData.spreads[stepSpreadIndex]?.pages.length || 1;
  return Math.max(spreadsPerStep, 1) * pagesPerSpread;
}

export default getPagesPerStep;
